/**
 * Authentication actions
 */
export const AUTH_ACTIONS = {
  LOGIN_PAGE_VIEWED: 'login_page_viewed',
  LOGIN_PAGE_EXIT: 'login_page_exit',
  LOGIN_ATTEMPT: 'login_attempt',
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAILED: 'login_failed',
  LOGOUT: 'logout',
  REGISTRATION_STARTED: 'registration_started',
  REGISTRATION_STEP_COMPLETED: 'registration_step_completed',
  REGISTRATION_STEP_BACK: 'registration_step_back',
  REGISTRATION_COMPLETED: 'registration_completed',
  REGISTRATION_FAILED: 'registration_failed',
  REGISTRATION_PAGE_EXIT: 'registration_page_exit',
  PASSWORD_RESET_REQUESTED: 'password_reset_requested',
  PASSWORD_RESET_SENT: 'password_reset_sent',
  PASSWORD_RESET_COMPLETED: 'password_reset_completed',
  PASSWORD_RESET_FAILED: 'password_reset_failed',
  USER_TYPE_SELECTED: 'user_type_selected',
  TERMS_VIEWED: 'terms_viewed',
  PRIVACY_VIEWED: 'privacy_viewed',
  VERIFICATION_SUCCESS: 'verification_success',
  VERIFICATION_FAILED: 'verification_failed',
  VERIFICATION_RESENT: 'verification_resent',
  AUTH_REDIRECT: 'auth_redirect',
} as const;
